<rask-container-block>
  <div class="row">
    <rask-hot-doc
      [hotDoc]="hotDoc">
    </rask-hot-doc>
  </div>
  <div class="row">
    @if (!viewModel.isMassEditering) {
      <div class="btn-group">
        <rask-button type="button" aid="fargmarkning1" [disabled]="!viewModel.canEdit" color="primary"
        (click)="setFargMarkning(1)">Färg 1</rask-button>
        <rask-button type="button" aid="fargmarkning2" [disabled]="!viewModel.canEdit" color="primary"
        (click)="setFargMarkning(2)">Färg 2</rask-button>
        <rask-button type="button" aid="fargmarkning3" [disabled]="!viewModel.canEdit" color="primary"
        (click)="setFargMarkning(3)">Färg 3</rask-button>
        <rask-button type="button" aid="rensa-fargmarkning" [disabled]="!viewModel.canEdit" color="primary"
        (click)="rensaFargmarkning()">Rensa markerade</rask-button>
      </div>
    }
  </div>
</rask-container-block>
